const STARTS_WITH_FORWARD_SLASH = /^\//
const SAFE_PATH_PATTERN = /[^/\-_.\w?=]/g

export const sanitizeEncoding = (path) => {
  if (!path) return ''

  const decodedPath = decodeURIComponent(path)

  if (STARTS_WITH_FORWARD_SLASH.test(decodedPath)) {
    const sanitizedPath = decodedPath.replace(SAFE_PATH_PATTERN, '')
    return sanitizedPath
  }
  return '/app/scheduled_events/user/me'
}
